module.exports = __webpack_public_path__ + "img/top1.03f548d3.png";